import {useSearchParams} from "react-router-dom";
import {AccountSwitcherDetails} from "@bounce/shared/consumer/declarations";
import {useGetUserQuery} from "~/api/requests";
import {getBundleKey} from "@bounce/shared/helpers";
import {getBundleAccounts} from "~/new-design/utils";
import {useAccount} from "./useAccount";

export const useBundleAccounts = () => {
  const [searchParams] = useSearchParams();
  const {account} = useAccount();
  const {data: user} = useGetUserQuery({});

  const bundleDetails = account?.bundle_details;
  const isBundled = !!bundleDetails?.bundle_eligible && !searchParams.get("singleAccount");
  const switcher = (user?.accounts_switcher ?? []) as AccountSwitcherDetails[];

  return {
    isBundled,
    bundleAccounts:
      isBundled && account?.partner_code
        ? getBundleAccounts(switcher, account.partner_code, getBundleKey(bundleDetails))
        : [],
    totalBundleBalance: bundleDetails?.total_bundle_balance,
    lowestBundleInstallment: bundleDetails?.bundle_lowest_monthly_installment_size,
  };
};
